import { useEffect } from "react";

import AdminContentSettingsSearchFormOverlay from "@/admin/AdminContentSettingsSearchFormOverlay";
import getIdsOfContentSettingsGroups from "@/admin/utils/getIdsOfContentSettingsGroups";
import { useAdminContentSettingsContext } from "@/search/AdminContentSettingsContext/AdminContentSettingsContext";
import { URL_PARAMS } from "../NewSearchPageMVP.constants";
import { useSearchPageContext } from "../provider/SearchPageProvider";
import { AgathaSchemaParamsEnum } from "../types/IParametersSchema";
import { useContentSettings } from "./hooks/useContentSettings";

export const SearchContentSettings = () => {
  const {
    contentSettingsGroups,
    contentSettingsToggleEnabled,
    enableContentSettingFeatures,
    setContentSettingsToggleEnabled,
  } = useAdminContentSettingsContext();
  const {
    handlers: {
      getSearchParamValues,
      setSearchParamValue,
      hasSearchParamValue,
    },
  } = useSearchPageContext();

  const { invokeContentSettingsSearchModeChange } = useContentSettings();

  const enableContentSettingsParam = hasSearchParamValue(
    AgathaSchemaParamsEnum.admin_content_settings,
    "true",
  );

  useEffect(() => {
    if (contentSettingsToggleEnabled && enableContentSettingFeatures) {
      setSearchParamValue(
        AgathaSchemaParamsEnum.admin_content_settings,
        "true",
      );
    }

    const consetGroupIds = getIdsOfContentSettingsGroups({
      gradeRanges: getSearchParamValues(URL_PARAMS.gradeGroups),
      contentSettingsGroups,
    });
    if (consetGroupIds?.length > 0) {
      setSearchParamValue(URL_PARAMS.consetGroupIds, consetGroupIds.join(","));
    }
  }, [contentSettingsToggleEnabled, enableContentSettingFeatures]);

  useEffect(() => {
    setContentSettingsToggleEnabled(enableContentSettingsParam);
  }, [enableContentSettingsParam]);

  return (
    <>
      <AdminContentSettingsSearchFormOverlay
        invokeContentSettingsSearchModeChange={
          invokeContentSettingsSearchModeChange
        }
      />
    </>
  );
};
